<template>
  <div class="log-event">
    <div class="not-support"></div>
    <div>
      <div class="empty-content" v-if="value === 'Kubernetes'">
        {{ $t('label.setupKubernetes') }}<br />
        <span class="comment-color">{{ $t('label.setupKubernetesPath') }}</span>
      </div>
      <div class="empty-content" v-else-if="value === 'CloudFunctions'">
        {{ $t('label.setupCloudFunctions') }}<br />
        <span class="comment-color">{{ $t('label.setupCloudFunctionsPath') }}</span>
      </div>
      <div class="empty-content" v-else-if="value === 'Agent'">
        {{ $t('label.setupAgent') }}<br />
        <span class="comment-color">{{ $t('label.setupAgentPath') }}</span>
      </div>
      <div class="empty-content" v-else-if="value === 'NotSupport'">
        {{ $t('label.logMonitoringNotSupport') }}
      </div>
      <div class="empty-content" v-else-if="value === 'Event'">
        {{ $t('label.setupEvent') }}<br />
        <span class="comment-color">{{ $t('label.setupEventPath') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import i18nMixin from '@/mixins/i18n.mixin.js';

export default {
  name: 'SetLogEvent',
  mixins: [i18nMixin],
  components: {},
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.log-event {
  display: flex;
  flex-direction: column;
}
.comment-color {
  color: #787c84;
}
.not-support {
  display: block;
  width: 180px;
  height: 140px;
  margin: 0 auto;
  background-image: url(../../../assets/img/scmp/img_agent.png);
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 180px 134px;
}
.empty-wrap {
  display: flex;
  text-align: center;
  flex-direction: column;
  gap: 8px;
}
.not-event {
  display: block;
  width: 180px;
  height: 140px;
  margin: 0 auto;
  background-image: url(../../../assets/img/scmp/img_event.png);
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 180px 134px;
}
.empty-content {
  display: flex;
  text-align: center;
  flex-direction: column;
  gap: 8px;
}
</style>
